/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestEvidences200ResponseInnerWarnings
 */
export interface GetPaymentRequestEvidences200ResponseInnerWarnings {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'detectedDpi'?: GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'calculatedDpi'?: GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'colorGradation'?: GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'heightMillis'?: GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestEvidences200ResponseInnerWarnings
     */
    'widthMillis'?: GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum;
}

export const GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsDetectedDpiEnum];
export const GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsCalculatedDpiEnum];
export const GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsColorGradationEnum];
export const GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsHeightMillisEnum];
export const GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum = typeof GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum[keyof typeof GetPaymentRequestEvidences200ResponseInnerWarningsWidthMillisEnum];


